"use client"

import { BlockRenderer, Container, CustomBreadcrumbs, TopBanner } from "ui"
import { extractProperty, getBreadCrumbs } from "utils"
import { findProperty } from "utils/findProperty"
import ShareholdersMain from "./ShareholdersMain"

type Props = {
  data: any
  stockHolderData: any
  locale: string
  asOf: string
}

function InvestorsShareholders({ data, stockHolderData, locale, asOf }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    pgeMainTitle: ShareholdersMain,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )

  const dateTextBlock = blocks.find((block: any) => block.blockType === "shareholdersDate")
  const dateText = extractProperty(dateTextBlock, "dateText")

  return (
    <>
      <Container>
        <CustomBreadcrumbs current={selfObject} parents={parents} />
      </Container>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
          }
        } else if (block.blockType === "pgeMainTitle") {
          additionalProps = {
            stockHolderData: stockHolderData,
            asOf,
            dateText,
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}

export default InvestorsShareholders
